import { useTranslation } from "react-i18next";
import { translate as tr } from "../../i18n";
import React, { useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import {useSelector, useDispatch} from "react-redux";
import {LOGIN_SUCCESS} from "../../actions/types";
import {loadUser} from "../../actions/auth";

export default function InvitePage () {
  useTranslation();
    const history = useNavigate();
    const auth = useSelector(state=>state.auth);
    const dispatch = useDispatch();

    const getInviteId = () => {
        const url = new URL(window.location.href);
        return url.searchParams.get("id");
    };

    useEffect(() => {
        if (auth.loading) {
            return;
        }
        if (!auth.loading && auth.isAuthenticated && !getInviteId()) {
            history("/dashboard");
            return;
        }
        checkUser();
    },[auth.loading, auth.isAuthenticated, history]);

    const  checkUser = async () => {
        try {
        let url_string = window.location.href;
        var url = new URL(url_string);
        var c = url.searchParams.get("id");
        if(c) {
            let text = atob(c);
            let data = text.split(' ');
            let email = data[1];
            let invite_id = data[0];
            let workspace_id ;

            const config = {
                headers: {
                  "Content-Type": "application/json",
                },
            };

            const body = JSON.stringify({ invite_id, email });
            let res = await axios.post("/api/invitation/getuser", body, config );
            if(res.status === 200) {
                const invite_detail = res.data.invite_detail;
                const user_detail = res.data.user_detail;
                const admin_email = res.data.admin_detail[0].email;
                const admin_name = res.data.admin_detail[0].first_name + ' ' +  res.data.admin_detail[0].last_name;
                const workspace_title = res.data.admin_detail[0].workspace_title;
                if(invite_detail.length > 0 &&
                    invite_detail[0].is_accepted === 0 &&
                    invite_detail[0].is_joining === 1) {

                    workspace_id = invite_detail[0].workspace_id;
                    let data = `${workspace_id} ${email} ${invite_id}`;
                    let enData = btoa(data);
                    if(user_detail.length > 0) {
                        const currentUserId = auth.user_id ? parseInt(atob(auth.user_id), 10) : null;
                        if(currentUserId !== null && user_detail[0].id === currentUserId) {
                            let team_name = `${user_detail[0].first_name} ${user_detail[0].last_name}`
                            const config = {
                                headers: {
                                  "Content-Type": "application/json",
                                },
                                withCredentials: true,
                            };
                            const body = JSON.stringify({
                                user_id: currentUserId,
                                workspace_id,
                                team_name,
                                invite_id,
                                admin_email,
                                admin_name,
                                workspace_title
                            })
                            let res1 = await axios.post("/api/invitation/accept", body , config)
                            if (res1.status === 200) {
                                dispatch({ type: LOGIN_SUCCESS, payload: res1.data });
                                dispatch(loadUser(res1.data));
                                history("/dashboard");
                              }

                        }
                        else {
                            history("/login?data="+enData)
                        }
                    }
                    else {
                        history("/?data="+enData)
                    }
                }
                else {
                    history("/login");
                }
            }
        }
        else {
            history(auth.isAuthenticated ? "/dashboard" : "/");
        }
      }
      catch (err) {
          console.log(err)
      }
    }

    return (
        <div>
            <h2>{tr("The Invitation Page .... !")} </h2>
        </div>
    )
}
